<template>
  <div class="centerBox">
    <div class="newsInfo centBoxIn">
      <topCarousel :banners="bannerList" />
      <div class="newsInfoContOut">
        <div class="newsInfoCont">
          <div class="title">资讯动态</div>
          <div class="tabBtn">
            <p
              v-for="(tabItem, index) in tabList"
              :key="tabItem.name"
              :class="['tabItem', { active: index == curTabInd }]"
              @click="changeTab(index)"
            >
              {{ tabItem.name }}
            </p>
          </div>
          <div class="newsList">
            <template v-for="item in newsList">
              <itemNews
                @click.native="() => toNewsDetail(item.id)"
                :newsInfo="item"
                :key="item.id"
              />
            </template>
            <el-pagination
              class="pagination"
              @current-change="handleCurChange"
              :current-page.sync="queryParams.pageIndex"
              background
              layout="prev, pager, next"
              :total="total"
              :page-size.sync="queryParams.pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- <div class="preloadFont">提前加载字体文件</div> -->
    </div>
  </div>
</template>

<script>
import TopCarousel from "@/components/TopCarousel";
import ItemNews from "./components/ItemNews.vue";

import { getBanners } from "@/utils/tool";
import { getArticleList } from "@/api/news";

export default {
  name: "newsInfo",
  components: { TopCarousel, ItemNews },
  data() {
    return {
      curTabInd: 0,
      bannerList: [],
      tabList: [],
      newsList: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  mounted() {
    this.bannerList = getBanners("/news");
    this.curTabInd = this.$route.query.tab || 0;
    this.initTabList();
    this.getArtList();
  },
  methods: {
    initTabList() {
      const navList = JSON.parse(localStorage.getItem("navList"));
      const tabList = navList.find((item) => item.path == "/news").class;
      if (tabList) {
        this.tabList = tabList;
      }
    },
    handleCurChange(pageIndex) {
      this.queryParams.pageIndex = pageIndex;
      this.getArtList(this.queryParams);
    },
    changeTab(index) {
      this.curTabInd = index;
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: index,
        },
      });
    },
    getArtList(pageInfo = { pageIndex: 1, pageSize: 5 }) {
      if (pageInfo) {
        this.queryParams = pageInfo;
      }
      const { id } = this.tabList[this.curTabInd];
      getArticleList(id, this.queryParams).then((res) => {
        if (res.code == 200) {
          this.newsList = res.data.list;
          this.total = res.data.count;
        }
      });
    },
    toNewsDetail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          ...this.$route.query,
          id,
        },
      });
    },
  },
};
</script>

<style scoped>
.newsInfo .newsInfoContOut {
  background-color: #f3f5f9;
  width: 100%;
}
.newsInfo .newsInfoCont {
  margin: 0 auto;
  box-sizing: border-box;
  width: var(--content-width);
  min-width: var(--content-min-width);
  padding: 0 20px;
}
.newsInfo .newsInfoCont .title {
  font-weight: 600;
  font-size: 45px;
  color: #1a1a1a;
  text-align: center;
  padding-top: 64px;
}
.newsInfo .newsInfoCont .tabBtn {
  font-weight: 600;
  font-size: 29px;
  text-align: left;
  padding-top: 65px;
  padding-bottom: 30px;
}
.newsInfo .newsInfoCont .tabBtn p {
  display: inline-block;
  cursor: pointer;
  margin-right: 10px;
  width: 140px;
  height: 40px;
  font-weight: 600;
  font-size: 26px;
  color: #1a1a1a;
  text-align: center;
}
.newsInfo .newsInfoCont .tabBtn p.tabItem {
  display: inline-block;
}
.newsInfo .newsInfoCont .tabBtn p.tabItem:hover,
.newsInfo .newsInfoCont .tabBtn p.tabItem.active {
  background-image: url("../../common/images/other/title_bg.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  color: #318af9;
}

.newsInfo .newsInfoCont .newsList {
}

.pagination {
  padding: 62px 0;
  text-align: center;
}
.newsList >>> .el-pagination.is-background .btn-prev,
.newsList >>> .el-pagination.is-background .btn-next {
  border: 1px solid #707070;
  width: 56px;
  height: 56px;
}
.newsList >>> .el-pagination.is-background .btn-prev .el-icon,
.newsList >>> .el-pagination.is-background .btn-next .el-icon {
  font-size: 25px;
  font-weight: normal;
}
.newsList >>> .el-pagination.is-background .el-pager li {
  border: 1px solid #707070;
  min-width: 56px;
  height: 56px;
  line-height: 56px;
  font-size: 25px;
  font-weight: normal;
}
.newsList >>> .el-pagination.is-background .el-pager li:not(.active):hover {
  border-color: #398fff;
  color: #398fff;
}
.newsList >>> .el-pagination.is-background .el-pager li.active {
  background-color: #398fff;
  border-color: #398fff;
}
/* .preloadFont {
  visibility: hidden;
  font-size: 0;
  height: 0;
  width: 0;
  font-family: Alibaba PuHuiTi ExtraBold;
} */
</style>



// WEBPACK FOOTER //
// src/views/news/index.vue